import { Textarea } from '@components/Textarea';
import type { DescriptionFieldNames } from '@store/Task';

interface Props {
    disabled?: boolean;
    title: string;
    name?: DescriptionFieldNames;
    value?: string;
    minRows?: number;
    placeholder?: string;
    dataTest: string;
    onChange(e: React.ChangeEvent<HTMLTextAreaElement>): void;
}

export function DescriptionTextInput({
    disabled,
    title,
    name,
    value,
    minRows,
    placeholder,
    dataTest,
    onChange,
}: Props): React.ReactElement<any> {
    return (
        <Textarea
            dataTest={dataTest}
            disabled={disabled}
            title={title}
            placeholder={placeholder}
            value={value ?? ''}
            minRows={minRows}
            name={name}
            onChange={onChange}
        />
    );
}
